// extracted by mini-css-extract-plugin
export default {"secondaryOrangeButton":"_1LRO6a-tVOicRLC89CWlaq","secondaryOrangeButtonMSK":"_3OsMeuxc4ZXfBTz8wd2Vxo"};